import { useEffect, useState } from "react";
import { WifiOff, CloudUpload } from "lucide-react";
import { pendingList, retryPending } from "@/lib/pendingQuote";

// Bandeau hors ligne + devis en attente d'envoi
export const ConnectionBanner = () => {
  const [down, setDown] = useState(typeof navigator !== "undefined" && navigator.onLine === false);
  const [pending, setPending] = useState(() => pendingList().length);
  useEffect(() => {
    const on = () => setDown(false);
    const off = () => setDown(true);
    const net = (e) => setDown(!!e.detail?.down || navigator.onLine === false);
    const pc = () => setPending(pendingList().length);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    window.addEventListener("net:state", net);
    window.addEventListener("pending:change", pc);
    window.addEventListener("storage", pc);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      window.removeEventListener("net:state", net);
      window.removeEventListener("pending:change", pc);
      window.removeEventListener("storage", pc);
    };
  }, []);
  if (!down && !pending) return null;
  const n = pending > 1 ? `${pending} devis enregistrés sur l'appareil` : "1 devis enregistré sur l'appareil";
  const verb = down ? (pending > 1 ? " seront envoyés dès le retour du réseau." : " sera envoyé dès le retour du réseau.") : " en cours d'envoi.";
  return (
    <div className={`no-print text-white text-xs sm:text-sm px-4 py-1.5 flex items-center justify-center gap-2 flex-wrap ${down ? "bg-amber-500" : "bg-sky-600"}`} role="status" data-testid="connection-banner">
      {down ? <WifiOff className="w-4 h-4 shrink-0" /> : <CloudUpload className="w-4 h-4 shrink-0" />}
      <span data-testid="connection-banner-text">
        {down ? "Mode hors ligne : vous pouvez continuer à configurer et enregistrer vos devis sur cet appareil." : "Connexion rétablie."}
        {pending > 0 && ` ${n}${verb}`}
      </span>
      {!down && pending > 0 && (
        <button type="button" onClick={() => retryPending()} className="underline font-semibold" data-testid="pending-send-now">Envoyer maintenant</button>
      )}
    </div>
  );
};
